/*
 * Dolgum — real Instagram UGC promo on the product page.
 * Links out to the brand's real @dolgumshop posts. NOTE: an earlier version
 * of this embedded Instagram's official iframe widget (embed.js) directly on
 * the page, but in testing it rendered as a blank box — third-party embeds
 * like Instagram's are widely blocked by default in Safari (ITP), Firefox
 * (ETP), Brave and many ad/privacy blockers, so a meaningful share of real
 * visitors would have seen a broken empty box instead of content, which
 * hurts trust more than it helps. This version instead shows real, working
 * links to the actual reels — genuine content, reliably rendered for
 * everyone, no risk of a blank/broken widget.
 * Additive/non-destructive: only ever appends new elements.
 */
(function () {
  var isProductPage = /\/products\//.test(window.location.pathname);
  if (!isProductPage) return;

  var ACCENT = 'rgb(var(--color-button))';
  var ACCENT_TEXT = 'rgb(var(--color-button-text))';

  var REELS = [
    { url: 'https://www.instagram.com/dolgumshop/reel/DdSLbykBLQX/', label: 'Reel 1' },
    { url: 'https://www.instagram.com/dolgumshop/reel/DdPIzSmxXCx/', label: 'Reel 2' },
    { url: 'https://www.instagram.com/dolgumshop/reel/DdjiYF7BQzf/', label: 'Reel 3' }
  ];

  function injectStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectStyle(
    '.eai3-ugc{margin-top:1.25rem;font-family:var(--font-body-family);background:linear-gradient(135deg,rgba(215,174,168,.12),rgba(215,174,168,.03));' +
    'border-radius:14px;padding:1.1rem 1.2rem;}' +
    '.eai3-ugc__title{font-family:var(--font-heading-family);font-size:1.25rem;font-weight:700;' +
    'color:#1f2937;margin:0 0 .3rem;display:flex;align-items:center;gap:.4rem;}' +
    '.eai3-ugc__sub{font-size:.95rem;color:#6b7280;margin:0 0 .9rem;}' +
    '.eai3-ugc__row{display:flex;flex-wrap:wrap;gap:.6rem;align-items:center;}' +
    '.eai3-ugc__reel{display:inline-flex;align-items:center;gap:.35rem;background:#fff;' +
    'border:1.5px solid rgba(0,0,0,.08);border-radius:20px;padding:.5rem 1rem;font-size:.92rem;' +
    'font-weight:600;color:#1f2937;text-decoration:none;transition:border-color .15s ease;}' +
    '.eai3-ugc__reel:hover{border-color:' + ACCENT + ';}' +
    '.eai3-ugc__follow{display:inline-flex;align-items:center;gap:.5rem;background:' + ACCENT + ';' +
    'color:' + ACCENT_TEXT + ';border-radius:20px;padding:.6rem 1.2rem;font-size:.95rem;font-weight:700;' +
    'text-decoration:none;}'
  );

  function render() {
    if (document.querySelector('.eai3-ugc')) return;
    var anchor = document.querySelector('.eai2-refer') || document.querySelector('.eai-trust-row');
    if (!anchor) return;

    var reelLinks = REELS.map(function (r) {
      return '<a class="eai3-ugc__reel" href="' + r.url + '" target="_blank" rel="noopener noreferrer">▶ ' + r.label + '</a>';
    }).join('');

    var box = document.createElement('div');
    box.className = 'eai3-ugc';
    box.innerHTML =
      '<p class="eai3-ugc__title">📸 Real Customers, Real Cats</p>' +
      '<p class="eai3-ugc__sub">See it in action on our real Instagram — genuine posts from @dolgumshop.</p>' +
      '<div class="eai3-ugc__row">' +
        reelLinks +
        '<a class="eai3-ugc__follow" href="https://www.instagram.com/dolgumshop/" target="_blank" rel="noopener noreferrer">Follow @dolgumshop →</a>' +
      '</div>';
    anchor.insertAdjacentElement('afterend', box);
  }

  render();
  var mo = new MutationObserver(render);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
